<template>
  <v-container class="py-5" style="max-width: 90vw">
    <div style="display: flex" class="justify-space-between align-center">
      <div>
        <title-icon-component
          title="Jalan Irigasi dan Jaringan Rumpun Jalan dan Transportasi"
          image="jalan_irigasi_perbaikan.svg"
        />
        <breadcrumbs-component :crumbs="crumbs" />
      </div>
      <div>
        <v-btn
          class="text-capitalize"
          href="/aset/jalan-irigasi-jaringan/riwayat"
          >Lihat Riwayat</v-btn
        >
        <!--        <v-btn-->
        <!--          @click="download"-->
        <!--          class="white&#45;&#45;text text-capitalize ml-2"-->
        <!--          color="#004643"-->
        <!--          >Download</v-btn-->
        <!--        >-->
      </div>
    </div>

    <table-component
      v-if="!isLoading"
      class="mt-5"
      :headers="tableHeaders"
      :items="computedAssets"
      :enable-download="true"
      file-name="aset_jalan_irigasi_dan_jaringan.xlsx"
      :limit="limit"
      :page="page"
      @update:limit="updateLimit"
      @update:page="updatePage"
      :asset_price="price"
    />
    <v-skeleton-loader v-else type="table" />
    <v-snackbar v-model="snackbar" :timeout="timeout" shaped top color="white">
      {{ message }}
      <template v-slot:action="{ attrs }">
        <v-btn color="#004643" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import TableComponent from "@/components/TableComponent.vue";
import TitleIconComponent from "@/components/TitleIconComponent.vue";
import BreadcrumbsComponent from "@/components/BreadcrumbsComponent.vue";
import { monthToYearMonth } from "@/plugins/helpers";
export default {
  components: {
    TableComponent,
    TitleIconComponent,
    BreadcrumbsComponent,
  },
  beforeMount() {
    this.init();
  },
  methods: {
    async init() {
      this.isLoading = true;
      this.page = parseInt(this.$route.query.page) || 1;
      this.limit = parseInt(this.$route.query.limit) || 20;

      if (
        this.$route.query?.page?.toString() !== this.page?.toString() ||
        this.$route.query?.limit?.toString() !== this.limit?.toString()
      ) {
        await this.$router.push({
          query: { ...this.$route.query, page: this.page, limit: this.limit },
        });
      }

      await this.$axios.get("/all-assets?category=3").then((response) => {
        this.assets = response.data.data.assets;
        this.price = response.data?.prices?.length
          ? response.data.prices[0]?.total?.infrastructure_price
          : 0;
        this.assignHeaders();
      });

      this.isLoading = false;
    },
    assignHeaders() {
      const headers = [
        {
          text: "Perbaikan",
          value: "total_repairs",
        },
        {
          text: "System ID",
          value: "id",
        },
        {
          text: "Kode Registrasi",
          value: "asset_code",
        },
        {
          text: "Nama Barang",
          value: "asset_name",
        },
        {
          text: "Seksi",
          value: "section",
        },
        {
          text: "Golongan",
          value: "asset_group",
        },
        {
          text: "Bidang",
          value: "asset_field",
        },
        {
          text: "Kelompok",
          value: "asset_classification",
        },
        {
          text: "Sub Kelompok",
          value: "asset_sub_classification",
        },
        {
          text: "Sub Sub Kelompok",
          value: "asset_sub_sub_classification",
        },
        {
          text: "Lokasi",
          value: "asset_location",
        },
        {
          text: "X Awal",
          value: "x_start",
        },
        {
          text: "X Akhir",
          value: "x_end",
        },
        {
          text: "Y Awal",
          value: "y_start",
        },
        {
          text: "Y Akhir",
          value: "y_end",
        },
        {
          text: "Sumber Dana",
          value: "funding_source",
        },
        {
          text: "Tahun Perolehan",
          value: "date_of_acquisition",
        },
      ];

      // if (this.assets.length > 0) {
      //   this.assets[0]["additional_properties"].forEach((item) => {
      //     headers.push({ text: item.name, value: item.name });
      //   });
      // }

      headers.push({
        text: "Foto",
        value: "foto",
        sortable: false,
        filterable: false,
      });

      headers.push({
        text: "",
        value: "arrow",
        sortable: false,
        filterable: false,
        width: "50px",
        align: "center",
      });
      this.tableHeaders = headers;
    },
    async download() {
      const queryParams = {
        category: "3",
      };

      try {
        const response = await this.$axios.get("/download-assets-by-category", {
          params: queryParams,
        });
        const mediaType =
          "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,";
        const base64Data = response.data.excelData;

        const url = mediaType + base64Data;

        const a = document.createElement("a");
        a.href = url;
        a.download = `Aset Jalan Irigasi dan Jaringan.xlsx`;
        await a.click();
        this.message = "Berhasil mendownload data";
        this.snackbar = true;
      } catch (error) {
        this.message = "Gagal mendownload data";
        this.snackbar = true;
        console.error("Error downloading file:", error);
      }
    },
    updateLimit(newLimit) {
      if (this.limit !== newLimit) {
        this.limit = newLimit;
        this.$router.push({
          query: { ...this.$route.query, limit: this.limit, page: 1 },
        });
      }
    },
    updatePage(newPage) {
      if (this.page !== newPage) {
        this.page = newPage;
        this.$router.push({ query: { ...this.$route.query, page: this.page } });
      }
    },
  },
  computed: {
    computedAssets() {
      const computedAssets = [];

      this.assets.forEach((asset) => {
        const computedAsset = {
          ...asset,
          href: "/aset/jalan-irigasi-jaringan/" + asset.id,
        };

        // asset["additional_properties"].forEach((item) => {
        //   computedAsset[item.name] = item.value;
        // });
        computedAsset["foto"] = asset.image_urls[0] || "";
        computedAsset["useful_life"] = monthToYearMonth(
          asset.useful_life_months
        );
        computedAsset["useful_life_remaining"] = monthToYearMonth(
          asset.useful_life_months_remaining
        );
        computedAssets.push(computedAsset);
      });
      return computedAssets;
    },
  },
  data: () => ({
    snackbar: false,
    message: "",
    timeout: 3000,
    assets: [],
    price: null,
    crumbs: [
      {
        text: "Layanan Aset",
        disabled: false,
        href: "/aset",
      },
      {
        text: "Jalan Irigasi dan Jaringan Rumpun Jalan dan Transportasi",
        disabled: true,
        href: "/aset/jalan-irigasi-jaringan",
      },
    ],
    tableHeaders: [],
    page: 1,
    limit: 20,
    isLoading: true,
  }),
};
</script>

<style></style>
